import * as accessToken from "./accessToken";
import * as authFacadeImpl from "./authFacadeImpl";
import * as authPage from "./authPage";
import * as authorizationCode from "./authorizationCode";
import * as loginResourceCacheFacadeImpl from "./loginResourceCacheFacadeImpl";
import * as serviceTicket from "./serviceTicket";

export const auth = {
  accessToken,
  authFacadeImpl,
  authPage,
  authorizationCode,
  loginResourceCacheFacadeImpl,
  serviceTicket,
};
